var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('fieldset',{staticClass:"form-group"},[_c('label',{staticClass:"text-primary"},[_vm._v("\n      "+_vm._s(_vm.label)+"\n    ")]),_c('div',[_vm._v(_vm._s(_vm.value))])])])}
var staticRenderFns = []

export { render, staticRenderFns }